export default function local(dis, store, client) {
  async function setLanguage(language) {
    dis({ type: 'local/upsert', payload: { language } })
  }

  async function setValidationErrors(errors) {
    dis({ type: 'local/upsert', payload: { validationErrors: errors } })
  }
  
  return {
    setLanguage,
    setValidationErrors
  }
}
